import { render, staticRenderFns } from "./custStatic.vue?vue&type=template&id=0cf7e7da&scoped=true&"
import script from "./custStatic.vue?vue&type=script&lang=js&"
export * from "./custStatic.vue?vue&type=script&lang=js&"
import style0 from "./custStatic.vue?vue&type=style&index=0&id=0cf7e7da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7e7da",
  null
  
)

component.options.__file = "custStatic.vue"
export default component.exports